export enum MIX_STATUS {
  UNMODIFIED = 'UNMODIFIED',
  MODIFIED = 'MODIFIED',
  UNCONSIDERED = 'UNCONSIDERED',
  PUBLISHED = 'PUBLISHED'
}
